import { ICriteria, ICriteriaUsageVariable } from '~/connect/types';

import {
  IQuoteBrandTemplateForm,
  IQuoteBrandTemplatePayload,
  IQuoteBrandTemplateWithBrands,
} from '~/connect/types';

export function fromFormToPayload(
  data: IQuoteBrandTemplateForm,
  criteria: ICriteria[],
): IQuoteBrandTemplatePayload {
  return {
    default: data.default,
    name: data.name,
    brands: data.brands.map((brand) => ({
      externalId: { id: brand.publicKey },
    })),
    criteria: data.criteria.map(({ criterion, values }) => ({
      criterion,
      values:
        criteria
          .find((criteria) => criteria.id === criterion.id)
          ?.values.filter((value) =>
            values.some((selectedValueId) => selectedValueId === value.id),
          ) ?? [],
    })),
    customerScope: data.customerScope.map((scope) => ({
      id: scope,
    })),
  };
}

export function toFormData(
  brandTemplate: IQuoteBrandTemplateWithBrands,
): IQuoteBrandTemplateForm {
  return {
    default: brandTemplate.default,
    name: brandTemplate.name,
    brands: brandTemplate.brands,
    criteria: brandTemplate.criteria.map(({ criterion, values }) => ({
      criterion,
      values: values.map((value) => value.id),
    })),
    customerScope: brandTemplate.customerScope,
  };
}

export function fromFormToQuery(
  id: string,
  data: IQuoteBrandTemplatePayload,
): ICriteriaUsageVariable {
  return {
    id: id,
    query: {
      criteria: data.criteria.map(({ criterion, values }) => ({
        criterion: criterion.id,
        values: values.map((v) => (v.id === undefined ? id : v.id)),
      })),
    },
  };
}
